import { type CreateMeterRequestPayload } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useCreateMeter(options?: UseMutationOptions<void, unknown, CreateMeterRequestPayload>) {
  return useMutation({
    mutationFn: async (createMeterRequest) => {
      const api = getPrivateApi();
      await api.createMeter({ createMeterRequest });
    },
    ...options,
  });
}
